module.exports = __webpack_public_path__ + "static/media/b.b49c0840.jpg";